import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import HowItWorks from './pages/HowItWorks';
import FAQ from './pages/FAQ';

function App() {
    return (
        <ErrorBoundary>
            <HelmetProvider>
                <Router>
                    <ScrollToTop />
                    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-indigo-50 flex flex-col">
                        <Navbar />
                        <main className="flex-grow">
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/about" element={<AboutUs />} />
                                <Route path="/how-it-works" element={<HowItWorks />} />
                                <Route path="/faq" element={<FAQ />} />
                            </Routes>
                        </main>
                        <Footer />
                    </div>
                </Router>
            </HelmetProvider>
        </ErrorBoundary>
    );
}

export default App;
